<script>
	import { variables } from '$lib/variables';
	import { basketId, basketListnew } from '$lib/store/newbasket';
	import { lang } from '$lib/translations/basket';
	import { page } from '$app/stores';
	import { fly } from 'svelte/transition';
	import noimage from '$lib/images/noimage.jpg';

	export let item;
	export let load;
	async function GetBasketNew() {
		let urls = `${variables.basePathApi}/api/v1/orders/user-auth/`;
		if ($page.data.access) {
			const res = await fetch(urls, {
				headers: {
					Authorization: 'Bearer ' + $page.data.access
				}
			});
			if (res.status === 200) {
				let baskData = await res.json();
				$basketListnew = baskData;
				$basketId = baskData.id;
			}
		} else {
			const res = await fetch(urls, {});
			if (res.status === 200) {
				let baskData = await res.json();
				$basketListnew = baskData;
				$basketId = baskData.id;
			}
		}
	}
	async function GetBasket(pk) {
		let url = `${variables.basePathApi}/api/v1/orders/${pk}/for-client/`;
		const res = await fetch(url);
		if (res.status === 200) {
			$basketListnew = await res.json();

			$basketListnew = $basketListnew;
		} else {
			await GetBasketNew();
		}

		load = false;
		return;
	}
	async function ChangeCount(val) {
		let count = item.total;
		if (val === '-') {
			if (count != 1) {
				count = count - 1;
			} else {
				return;
			}
		} else {
			if (count < item.product.total) {
				count = count + 1;
			} else {
				return;
			}
		}
		load = true;
		let datas = {
			total: count
		};
		let url = `${variables.basePathApi}/api/v1/items-order/${item.id}/`;
		let method = 'PATCH';

		const res = await fetch(url, {
			method: method,
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(datas)
		});
		if (res.status === 201 || res.status === 200) {
			await GetBasket($basketId);
		}
		load = false;
	}
	async function Remove() {
		load = true;
		let url = `${variables.basePathApi}/api/v1/items-order/${item.id}/`;
		const res = await fetch(url, {
			method: 'DELETE',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		});

		if (res.status === 204) {
			await GetBasket($basketId);
		}
		load = false;
	}
</script>

<li
	transition:fly={{
		x: 200,
		duration: 500
	}}
	class:disabled={item.total === 0}
	class="flex py-6 sm:py-10"
>
	<div class="flex-shrink-0">
		{#if item.product.photos.length}
			<img
				src="{item.product.photos[0].image_thumbnail}"
				alt="Front of men&#039;s Basic Tee in sienna."
				class="h-24 w-24 flex-none rounded-md bg-gray-100 object-cover object-center"
			/>
		{:else}
			<img
				src={noimage}
				alt="Front of men&#039;s Basic Tee in sienna."
				class="h-24 w-24 flex-none rounded-md bg-gray-100 object-cover object-center"
			/>
		{/if}
	</div>

	<div class="ml-4 flex flex-1 flex-col justify-between sm:ml-6">
		<div class="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
			<div>
				<div class="flex justify-between">
					<div class="flex flex-col flex-wrap">
						<h3 class="text-[10px] text-custom-black">
							<a
								href="/{item.product.product.category.slug}/{item.product.id}"
								class="font-semibold text-gray-700 dark:text-gray-50 hover:text-gray-800"
								>{item.product.product[`name${$page.data.host}`]}</a
							>
						</h3>

						{#if item.product.color}
							<p class="mt-[10px]">
								{lang[$page.data.host]['colortile']}: {item.product.color[`name${$page.data.host}`]}
							</p>
						{/if}
						{#if item.product.sizes}
							<p class="mt-[10px]">
								{lang[$page.data.host]['size']}: {item.product.sizes.international}
							</p>
						{/if}
					</div>
				</div>
			</div>

			<div class="mt-4 sm:mt-0 sm:pr-9">
				<div class="absolute top-0 right-0">
					<button
						on:click={() => {
							Remove();
						}}
						type="button"
						class="-m-2 inline-flex p-2 text-gray-400 hover:text-gray-500"
					>
						<span class="sr-only">Remove</span>
						<svg
							class="h-5 w-5 block md:hidden"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
							/>
						</svg>
						<span class="hidden md:block">{lang[$page.data.host]['remove']}</span>
					</button>
				</div>
			</div>
		</div>
		{#if item.total > 0}
			<div class="flex justify-between">
				<div class="inline-flex text-custom-black text-[10px]">
					<button
						on:click={() => {
							ChangeCount('-');
						}}
					>
						-
					</button>
					<span class="ml-[14px] mr-[14px]">{item.total}</span>
					<button
						on:click={() => {
							ChangeCount('+');
						}}
					>
						+
					</button>
				</div>
				<div class="text-[10px] text-custom-black">
					{Number(item.all_total_price).toLocaleString('ru')}
					₽
				</div>
			</div>
		{:else}
			<span class="text-red-400">Товар закончился на складе</span>
		{/if}
	</div>
</li>
